import React from 'react';
import '../../styles/power-theme/PowerFormComponents.css';

/**
 * PowerButton - Tech-Style Button Component (Power Theme Only)
 *
 * Variants: primary (neon outline), secondary (subtle)
 * Only active when Power Theme is enabled
 *
 * @param {Object} props - Component props
 * @param {string} props.variant - Button variant: "primary" | "secondary" (default: "primary")
 * @param {string} props.type - Button type: "button" | "submit" | "reset" (default: "button")
 * @param {boolean} props.disabled - Disabled state
 * @param {boolean} props.fullWidth - Full width button
 * @param {string} props.icon - Icon emoji/character (optional)
 * @param {function} props.onClick - Click handler
 * @param {string} props.className - Additional CSS classes
 * @param {ReactNode} props.children - Button content
 * @param {Object} props.rest - Additional HTML attributes
 */
const PowerButton = ({
  variant = 'primary',
  type = 'button',
  disabled = false,
  fullWidth = false,
  icon,
  onClick,
  className = '',
  children,
  ...rest
}) => {
  const variantClass = variant === 'secondary' ? 'power-button-secondary' : 'power-button-primary';
  const widthClass = fullWidth ? 'power-button-full' : '';

  return (
    <button
      type={type}
      className={`power-button ${variantClass} ${widthClass} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {icon && <span className="power-button-icon">{icon}</span>}
      <span className="power-button-text">{children}</span>
    </button>
  );
};

export default PowerButton;
